import { Cancel, Save } from '@mui/icons-material';
import { Divider, Grid, Typography } from '@mui/material';
import { ValidationErrors } from 'fluentvalidation-ts';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import CustomButton from '../../../../Common/Components/Controls/InputControls';
import { Loader } from '../../../../Common/Components/Loader';
import {
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import { OperationType, SqlServer } from '../Model/SqlServerModel';
import { sqlServerService } from '../SqlServerService';
import SqlServerCreateForm from './SqlServerForm';
import { generateSqlPassword } from '../Common/util';
import { showToast } from '../../../../lib/toast';

const SqlServerCreate = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(0);
  const [errors, setErrors] = useState<ValidationErrors<SqlServer>>({});
  const [sqlServer, setSqlServer] = useState<SqlServer>({
    AdminPassword: generateSqlPassword(16),
    UserName: '',
    ServerName: '',
    ResourceGroup: '',
    Subscription: '',
    ProductID: '',
    Role: 'primary',
    Region: 'northeurope',
    EnableElasticPool: true,
    TenantCount: 0,
    DataMaxSize: 50,
    EDtu: 50,
    PerDbDtu: 10,
    FailoverGroups: [],
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    if (type === 'checkbox') {
      setSqlServer({
        ...sqlServer,
        [name]: checked,
      });
    } else {
      setSqlServer({
        ...sqlServer,
        [name]: value,
      });
    }
  };

  const validate = () => {
    if (Object.keys(errors).length > 0) {
      Object.entries(errors).forEach(([key, value]) => {
        showToast({
          title: key + ' ' + value?.toString(),
          type: 'error',
        });
      });
      return false;
    }
    return true;
  };

  const cancel = () => {
    history.push('/sqlserver');
  };

  const saveSqlServer = () => {
    setLoading((prevState) => prevState + 1);
    if (validate()) {
      sqlServerService
        .addSqlServer(sqlServer.ServerName, sqlServer)
        .then((result) => {
          showToast({
            type: 'success',
            title: result.ServerName + ' added successfully',
          });
          cancel();
        })
        .catch((err) => {
          showToast({
            type: 'error',
            title: 'Failed to add Sql Server',
          });
          console.log(err);
        });
    }
    setLoading((prevState) => prevState - 1);
  };

  return (
    <div>
      <Loader loading={loading > 0} />
      <PaperWrapper>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Create Sql Server
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <SqlServerCreateForm
          errors={errors}
          onFieldChange={handleChange}
          setErrors={setErrors}
          sqlserver={sqlServer}
          setSqlServer={setSqlServer}
          sqlServerOperation={OperationType.Create}
        />
        <FooterWrapper>
          <FooterContainer>
            <Grid item xs={12} sm="auto">
              <CustomButton
                onClick={saveSqlServer}
                startIcon={<Save />}
                label="Save"
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <CustomButton
                onClick={cancel}
                startIcon={<Cancel />}
                label="Cancel"
              />
            </Grid>
          </FooterContainer>
        </FooterWrapper>
      </PaperWrapper>
    </div>
  );
};

export default SqlServerCreate;
